import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async () => await dponetAPI.get('/kanban_configuration')

const update = async ({ ...data }) => {
  return await dponetAPI.put('/kanban_configuration', {
    kanbanConfiguration: data,
  })
}

const kanbanConfigurations = { get, update }

export default kanbanConfigurations
